import { AuthStore } from './AuthStore';
import { CartStore } from './CartStore';
import { ViewStatusStore } from './ViewStatusStore';
import { AppConfigStore } from './AppConfigStore';

export class RootStore {
	authStore: AuthStore;
	cartStore: CartStore;
	viewStatusStore: ViewStatusStore;
	appConfigStore: AppConfigStore;

	constructor() {
		this.authStore = new AuthStore(this);
		this.cartStore = new CartStore(this);
		this.viewStatusStore = new ViewStatusStore(this);
		this.appConfigStore = new AppConfigStore();
	}


	getStores() {
		return {
			rootStore: this,
			viewStatusStore: this.viewStatusStore,
			authStore: this.authStore,
			cartStore: this.cartStore,
			appConfigStore: this.appConfigStore,
		}
	}

}

export const rootStore = new RootStore();
export const stores = rootStore.getStores();